import { Navigate } from "react-router-dom";
import { useCities } from "@/context/CityContext";

export default function Landing() {
  const { cities, visitor } = useCities();
  if (!visitor) return <Navigate to="/welcome" replace />;
  return cities.length ? <Navigate to="/marketplace" replace /> : <Navigate to="/select-city" replace />;
}
